/**
 * 步行/驾车/打车
 */
export enum FabricMapNaviType {
  /**
   * 自驾
   */
  drive = 0,
  /**
   * 步行
   */
  walking = 1,
  /**
   * 公共交通
   */
  bus = 2,
  /**
   * 火车
   */
  railway = 3,
  /**
   * 骑行
   */
  riding = 4,
}

/**
 * 路径类型; 单路径/多路径
 */
export enum FabricMapPathType {
  /**
   * 单路径
   */
  singleLine = 0,

  /**
   * 多路径
   */
  multiLine = 1,
}

export enum FabricMALineJoinType {
  /**
   * 斜面连接点
   */
  kMALineJoinBevel,
  /**
   * 斜接连接点
   */
  kMALineJoinMiter,
  /**
   * 圆角连接点
   */
  kMALineJoinRound,
}

export enum FabricMALineCapType {
  /**
   * 普通头
   */
  kMALineCapButt,
  /**
   * 扩展头
   */
  kMALineCapSquare,
  /**
   * 箭头
   */
  kMALineCapArrow,
  /**
   * 圆形头
   */
  kMALineCapRound,
}

/**
 * 虚线类型
 */
export enum FabricMALineDashType {
  /**
   * 不画虚线
   */
  kMALineDashTypeNone = 0,
  /**
   * 方块样式
   */
  kMALineDashTypeSquare,
  /**
   * 圆点样式
   */
  kMALineDashTypeDot,
}
